/**
 * App.tsx — composition root.
 * Providers (stack convention) + the platform auth gate. SK Voice owns NO login;
 * the SK Platform owns signup/verify/login for every product. RootNavigator
 * probes /v1/me and either renders the console (VoiceAppShell) or hands off to
 * the platform auth — the redirect-handoff pattern used by sk-catalog / skcrm.
 */

import React from 'react';

import { ThemeProvider } from './src/context/themeContext';
import { AppProvider } from './src/context/appContext';
import { SessionProvider } from './src/context/sessionContext';
import ToastHost from './src/components/toastHost';
import GlobalErrorBoundary from './src/components/globalErrorBoundary';
import RootNavigator from './src/navigation/rootNavigator';

export default function App() {
  return (
    <GlobalErrorBoundary>
      <ThemeProvider>
        <AppProvider>
          <SessionProvider>
            <RootNavigator />
            <ToastHost />
          </SessionProvider>
        </AppProvider>
      </ThemeProvider>
    </GlobalErrorBoundary>
  );
}
